const header = document.querySelector('.js-header');
const promobar = document.querySelector('.js-promobar');
const menus = [...document.querySelectorAll('.js-nav-sub')];

if(header) {
    const scrollHandler = () => {

        if(window.scrollY > (header.clientHeight + promobar.clientHeight)) {
            header.setAttribute('data-scrolled', '');
            header.classList.remove('header--transparent');
            promobar.setAttribute('data-scrolled', '');

        } else {
            header.removeAttribute('data-scrolled');

            if(header.getAttribute('data-transparent')) {
                header.classList.add('header--transparent');
            }
            promobar.removeAttribute('data-scrolled');
        }
        if(window.scrollY > 0) {
            menus.map(menu => {
                menu.classList.add('no-top');
            });

        }else {
            menus.map(menu => {
                menu.classList.remove('no-top');
            });
        }
    }

    scrollHandler();
    window.addEventListener('scroll', scrollHandler);
}
